const RANDOM_CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";

export const generateRandomString = (length: number): string =>
  Array.from(
    { length },
    () => RANDOM_CHARS[Math.floor(Math.random() * RANDOM_CHARS.length)],
  ).join("");

/**
 * Converts a slugged string (dash or underscore separated) into a human-readable title case string.
 * Example: "my-spark" -> "My Spark", "my_spark" -> "My Spark"
 */
export const desluggify = (str: string): string => {
  if (!str) return "";
  return str
    .split(/[-_]/)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

